import React from "react";
import { Grid, TextField, MenuItem, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const TransactionFilters = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            select
            label={t("transactions.filters.type")}
            value={filters.type}
            onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          >
            <MenuItem value="">
              {t("transactions.filters.allTypes", "All Types")}
            </MenuItem>
            <MenuItem value="credit_purchase">
              {t("transactions.types.creditPurchase")}
            </MenuItem>
            <MenuItem value="esim_purchase">
              {t("transactions.types.esimPurchase")}
            </MenuItem>
            <MenuItem value="esim_topup">
              {t("transactions.types.esimTopUp", "eSIM Top-up")}
            </MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            select
            label={t("transactions.filters.status")}
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <MenuItem value="">
              {t("transactions.filters.allStatuses", "All Statuses")}
            </MenuItem>
            <MenuItem value="completed">
              {t("common.status.completed")}
            </MenuItem>
            <MenuItem value="pending">{t("common.status.pending")}</MenuItem>
            <MenuItem value="failed">{t("common.status.failed")}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="date"
            label={t("transactions.filters.dateFrom")}
            InputLabelProps={{ shrink: true }}
            value={filters.dateFrom}
            onChange={(e) =>
              setFilters({ ...filters, dateFrom: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="date"
            label={t("transactions.filters.dateTo")}
            InputLabelProps={{ shrink: true }}
            value={filters.dateTo}
            onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TransactionFilters;
